<template>
  <div class="wrapper">
    <parallax
      class="page-header header-filter header-small"
      parallax-active="true"
      :style="headerStyle"
    >
      <div class="container">
        <div class="md-layout">
          <div
            class="md-layout-item md-size-66 md-small-size-100 mx-auto text-center"
          >
            <h2 class="title">
              A Place for Entrepreneurs to Share and Discover New Stories
            </h2>
          </div>
        </div>
      </div>
    </parallax>
    <div class="main">
      <div class="section">
        <div class="">
          <div class="md-layout" v-if="loaded">
            <div class="md-layout-item md-size-25 md-small-size-50" v-for="blog in blogs" :key="blog.id" >
              <full-bg-card :card-image="blog.cover">
                <template slot="cardContent">
                  <h6 class="card-category text-info">
                    {{blog.author}}
                  </h6>
                  <a href="javascript:void(0)">
                    <h3 class="card-title">
                      {{blog.title}}
                    </h3>
                  </a>
                  <h6 class="card-category text-info">
                    {{blog.created.d}}-{{blog.created.m}}-{{blog.created.y}}
                  </h6>
                  <md-button
                    v-on:click="openPost(blog.id, blog.title)"
                    class="md-danger md-round"
                  >
                    <md-icon>format_align_left</md-icon> Read Article
                  </md-button>
                </template>
              </full-bg-card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FullBgCard } from "@/components";
import Mixins from "@/plugins/basicMixins";
import firebase from "firebase";


export default {
  components: {
    
    FullBgCard,
    
  },
  mixins: [Mixins.HeaderImage],
  data() {
    return {
      blogs: [],
      loaded: false,
      subscribe: null,
      image: require("@/assets/img/examples/bg-blog-posts.jpg"),
      cardProject: {
        cardProject1: require("@/assets/img/examples/office2.jpg"),
        cardProject2: require("@/assets/img/examples/blog8.jpg"),
        cardProject3: require("@/assets/img/examples/card-project6.jpg")
      },
      cardProfile3: {
        cardProfile1: require("@/assets/img/faces/card-profile1-square.jpg"),
        cardProfile2: require("@/assets/img/faces/card-profile4-square.jpg")
      },
      cardBlog: {
        cardBlog1: require("@/assets/img/bg5.jpg"),
        cardBlog2: require("@/assets/img/examples/blog5.jpg"),
        cardBlog3: require("@/assets/img/examples/blog6.jpg")
      }
    };
  },
  created() {
    console.log("creating");
    const vm = this;
    firebase.firestore().collection("blog").where("type", "==", "PR").orderBy("created", "desc").get().then(blogs => {
      blogs.forEach(blog => {
        const blogData = blog.data()
        const date = blogData.created.toDate()
        vm.blogs.push({
          title: blogData.title,
          author: blogData.author,
          cover: blogData.cover,
          created: {
            d: date.getDate(),
            m: date.getMonth(),
            y: date.getFullYear()
          },
          id: blog.id
        })
      })
      vm.loaded = true;
    })
  },
  methods: {
    openPost(id, title) {
      title=title.replace(new RegExp(" ", "g"), "-")
      this.$router.push({ path: `/blog/${id}/${title}`})
    }
  }
};
</script>

<style lang="scss"></style>
